import type { SVGProps } from 'react';

const SvgCompanyFacebook = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M12 1.992c-5.51 0-10 4.49-10 10 0 5.511 4.49 10 10 10 5.511 0 10-4.489 10-10 0-5.51-4.489-10-10-10m0 2c4.43 0 8 3.57 8 8a7.98 7.98 0 0 1-6.781 7.899v-5.514h2.328l.365-2.365H13.22v-1.293c0-.983.32-1.856 1.24-1.856h1.477V6.8c-.26-.035-.809-.112-1.846-.112-2.166 0-3.435 1.144-3.435 3.75v1.575H8.428v2.365h2.226v5.494A7.98 7.98 0 0 1 4 11.992c0-4.43 3.57-8 8-8"
    />
    <path
      fill="currentcolor"
      d="M22 11.992c0-5.51-4.489-10-10-10-5.51 0-10 4.49-10 10 0 5.511 4.49 10 10 10 5.511 0 10-4.489 10-10m-8.78-1.272c0-.983.32-1.856 1.24-1.856h1.477V6.8c-.26-.035-.809-.112-1.846-.112-2.166 0-3.435 1.144-3.435 3.75v1.575H8.428v2.365h2.226v5.494A7.98 7.98 0 0 1 4 11.992c0-4.43 3.57-8 8-8s8 3.57 8 8a7.98 7.98 0 0 1-6.781 7.899v-5.514h2.328l.365-2.365H13.22zm8.831 1.273c0 5.539-4.511 10.05-10.05 10.05-5.538 0-10.05-4.511-10.05-10.05 0-5.538 4.512-10.05 10.05-10.05s10.05 4.512 10.05 10.05m-6.064-3.079H14.46a1 1 0 0 0-.922.534c-.189.33-.268.784-.268 1.272v1.243h2.702l-.009.058-.365 2.365-.007.042H13.27v5.403a7.925 7.925 0 0 0 6.681-7.838A7.935 7.935 0 0 0 12 4.042a7.935 7.935 0 0 0-7.95 7.95 7.93 7.93 0 0 0 6.555 7.819v-5.384H8.378v-2.465h2.227v-1.524c0-1.31.319-2.263.919-2.887s1.475-.913 2.566-.913c1.04 0 1.591.076 1.853.111l.043.006v2.158Z"
    />
  </svg>
);
export default SvgCompanyFacebook;
